<template>
  <div class="planned-transaction-layout-calendar-block">
    <div class="planned-transaction-layout-calendar group"
         :class="{'actions-enabled':!currentUserIsWatcher}">
      <div class="flex items-center">
        <AccountIcon :icon="transaction.template.account.icon"
                     :class="{'opacity-50':applyOpacity}"/>
        <AccountName :name="transaction.template.account.title"
                     :class="{'opacity-50':applyOpacity}"
                     class="truncate flex-1"/>
      </div>
      <div class="flex items-center truncate">
        <Category v-if="transactionCategory"
                  :category="transactionCategory"
                  :class="{'opacity-50':applyOpacity}"/>
      </div>
      <div class="justify-self-end flex">
        <Value :sum="+transaction.template.sum"
               class="md:pr-0"
               :class="{'line-through':transaction.off_budget,'opacity-50':applyOpacity}"
               :currency="transaction.template.account.currency"
               :isExpense="transaction.template.type === 2 || transaction.template.type === 4"
               :type="type"/>
      </div>
      <PlannedActions v-if="!currentUserIsWatcher"
                      class="-ml-6"
                      @confirm="$emit('confirm')"
                      @remove="$emit('remove')"
                      @edit="$emit('edit')"/>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import AccountIcon from "@/components/common/Transaction/TransactionItem/AccountIcon";
import AccountName from "@/components/common/Transaction/TransactionItem/AccountName";
import Category from "@/components/common/Transaction/TransactionItem/Category";
import Value from "@/components/common/Transaction/TransactionItem/Value";
import PlannedActions from "@/components/common/PlannedTransaction/PlannedTransactionItem/PlannedActions";

export default {
  name: "PlannedTransactionViewCalendar",
  components: {PlannedActions, AccountName, AccountIcon, Category, Value},
  props: {
    transaction: {
      type: Object,
      required: true
    },
    displayTime: {
      type: Boolean,
      required: true
    },
    applyOpacity: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher']),
    type() {
      return this.transaction.template.type === 1 ? 'income' : 'expense'
    },
    transactionCategory() {
      if (this.transaction.template.type === 1) {
        return this.transaction.template.income;
      } else {
        return this.transaction.template.expense;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.planned-transaction-layout-calendar-block {
  @apply relative;
  &:not(:last-of-type):after {
    @apply bg-border rounded w-full left-0 absolute rounded;
    content: '';
    height: 1px;
    bottom: 1px;
  }
}

.planned-transaction-layout-calendar {
  @apply flex py-4 items-center col-gap-6 relative;

  > div {
    transition: all .2s;

    &:nth-of-type(1) {
      width: 26%;
    }

    &:nth-of-type(2) {
      width: 0;
      flex: 1;
    }

    &:nth-of-type(3) {
      width: auto;
    }

    &:nth-of-type(4) {
      width: 0;
      opacity: 0;
      overflow: hidden;
    }
  }

  &.actions-enabled {
    > div:nth-of-type(3) {
      @apply -mr-4;
    }

    &:hover {
      > div:nth-of-type(3) {
        @apply mr-0;
      }

      > div:nth-of-type(4) {
        width: calc(2rem + 30px);
        opacity: 1;
      }
    }
  }
}

</style>